<template>
  <form-field-v2
    :label="label"
    :hint="hint"
    :error="error"
    :disabled="disabled"
  >
    <phone-input
      v2
      :show-flag-in-selection="false"
      :only-countries="countryIds"
      enable-search-country
      :error="!!error"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </form-field-v2>
</template>

<script>
import countries from 'shared/constants/countries.js';
import PhoneInput from 'dashboard/components/widgets/forms/PhoneInput.vue';
import FormFieldV2 from './FormFieldV2.vue';

const COUNTRY_IDS = countries.map(country => country.id);

export default {
  name: 'PhoneInputV2',
  components: { FormFieldV2, PhoneInput },
  inheritAttrs: false,
  props: {
    label: { type: String, default: '' },
    hint: { type: String, default: '' },
    error: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { countryIds: COUNTRY_IDS };
  },
};
</script>
